import React from 'react';
import HeroSection from './components/HeroSection';
import './App.css';

function App() {
  return (
    <div className="App">
      <HeroSection />
    </div>
  );
}

export default App;
